// ErrorBoard.jsx
import { Box } from "@mui/material";
import "./ErrorBoard.scss";

/**
 * @param {object} props
 * @param {string|null} props.message   - Feedback text
 * @param {"success"|"error"|"warning"|"info"|null} props.severity
 * @param {boolean} [props.visible=false]
 * @param {string} [props.className] - optional extra classes
 */
const ErrorBoard = ({
  message,
  severity = "info",
  visible = false,
  className = "",
}) => {
  const sev = severity; // ensure one of the class names exists
  const visibilityClass = visible ? "visible" : "hidden";

  return (
    <Box
      role="alert"
      aria-live="polite"
      className={`error-board ${visibilityClass} ${sev} ${className}`}
    >
      {visible && (
        <p>
          <strong>Message: </strong>
          {message}
        </p>
      )}
    </Box>
  );
};

export default ErrorBoard;
